//import "@babel/polyfill";
import "custom-event-polyfill";


require('./common/js/EventgalleryTools.js');

require('./frontend/js/EventgalleryCart.js');
require('./frontend/js/EventgalleryBehavior.js');
require('./frontend/js/EventgalleryImage.js');
require('./frontend/js/EventgalleryRow.js');
require('./frontend/js/EventgalleryImageList.js');
require('./frontend/js/EventgalleryCart.js');
require('./frontend/js/EventgalleryEventsList.js');
require('./frontend/js/EventgalleryEventsTiles.js');
require('./frontend/js/EventgalleryJSGallery2.js');
require('./frontend/js/EventgalleryLazyload.js');
require('./frontend/js/EventgallerySizeCalculator.js');
require('./frontend/js/EventgallerySocialShareButton.js');
require('./frontend/js/EventgallerySquareList.js');
require('./frontend/js/EventgalleryTilesCollection.js');
require('./frontend/js/EventgalleryTouch.js');
require('./frontend/js/EventgalleryGooglePhotosProcessor.js');
require('./frontend/js/EventgalleryCheckout.js');

require('./frontend/js/Modules.js');

require('./frontend/js/PhotoSwipeGallery.js');
require('./frontend/js/PhotoSwipeGallerySlide.js');

require('./frontend/less/eventgallery.less');
require('./frontend/less/font-awesome/font-awesome.less');

require("./photoswipe/photoswipe.css");
require("./photoswipe/default-skin/default-skin.css");



// Required Core Stylesheet
import "@glidejs/glide/src/assets/sass/glide.core.scss";
import "./frontend/sass/glide/glide.theme.scss";



